import { createContext, useContext, useMemo, useState } from "react";
import { translations, defaultLang } from "@/lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(defaultLang);

    const value = useMemo(
        () => ({
            lang,
            setLang,
            t: translations[lang],
            toggle: () => setLang((prev) => (prev === "en" ? "tr" : "en")),
        }),
        [lang],
    );

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLang() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
}
